import React, { ChangeEvent } from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function TextInput(props: Props) {
  const input = ({
    target,
  }: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    !props.isDisabled &&
    props.input(target.value.substring(0, props.maxLength || 5000));

  return props.isMultiline ? (
    <textarea
      className={classNames(styles.multilineTextInput, props.className, {
        [styles.invalidMultilineTextInput]: props.isInvalid,
      })}
      disabled={props.isDisabled}
      value={props.isSecured ? props.value.replaceAll(/./g, "•") : props.value}
      placeholder={props.placeholder}
      onChange={input}
      onBlur={props.blur}
      onFocus={props.focus}
      autoFocus={props.autoFocus}
    />
  ) : (
    <input
      type={props.isSecured ? "password" : "text"}
      disabled={props.isDisabled}
      className={classNames(styles.textInput, props.className, {
        [styles.invalidTextInput]: props.isInvalid,
      })}
      placeholder={props.placeholder}
      value={props.value}
      onChange={input}
      onBlur={props.blur}
      onFocus={props.focus}
      autoFocus={props.autoFocus}
    />
  );
}

export { TextInput };
